import { PAGE_PARAMS_DEFAULT_PAGE_SIZE } from "@selfai-platform/shared";

export const UI_SETTINGS_VIEW_PAGE_DEFAULT_SIZE = PAGE_PARAMS_DEFAULT_PAGE_SIZE;